import {
  LuUserCircle, LuLogOut, LuMenu,
} from 'react-icons/lu';
import CompanySwitcher from './CompanySwitcher';

const pageNames = {
  AssessmentTable:   { title: 'Consultar Avaliações',   subtitle: 'Consulte e gerencie as avaliações dos operadores' },
  Setup2FA:          { title: 'Segurança',               subtitle: 'Configure a autenticação em dois fatores' },
  ChangePasswordPage:{ title: 'Alterar Senha',           subtitle: 'Troque a senha da sua conta' },
  DepartmentsPage:   { title: 'Departamentos',           subtitle: 'Gerencie os departamentos e funcionários' },
  IndicatorsPage:    { title: 'Modelos de Avaliação',    subtitle: 'Configure os indicadores e pesos por departamento' },
  NewEvaluationPage: { title: 'Nova Avaliação',          subtitle: 'Lançamento de avaliação por departamento e funcionário' },
  TimeclockPage:     { title: 'Bater Ponto',             subtitle: 'Registre sua entrada ou saída' },
  TimesheetPage:     { title: 'Folha de Ponto',          subtitle: 'Consulte e gerencie os registros de ponto' },
  EmployeesPage:     { title: 'Funcionários',             subtitle: 'Cadastre e gerencie os funcionários por departamento' },
  UsersAdminPage:    { title: 'Usuários',                subtitle: 'Gerencie os usuários e seus vínculos com funcionários' },
  ActiveSessionsPage:{ title: 'Sessões Ativas',          subtitle: 'Usuários conectados agora' },
  TrainingCoursesPage: { title: 'Treinamentos',          subtitle: 'Cursos de capacitação da DHR Consultoria' },
  CompanyModulesPage: { title: 'Módulos por Empresa',    subtitle: 'Quais empresas clientes podem usar cada módulo' },
  OperatorPerformanceReportPage: { title: 'Avaliação por Período', subtitle: 'Evolução do desempenho do operador mês a mês' },
  ReportsPage:       { title: 'Relatórios Legais',       subtitle: 'Espelho de ponto, AFD, AEJ e comprovantes' },
  HolidaysPage:      { title: 'Feriados',                subtitle: 'Calendário de feriados nacionais, estaduais e municipais' },
  CompaniesPage:     { title: 'Empresas / Filiais',      subtitle: 'Cadastro de empresas e filiais' },
  AuditPage:         { title: 'Auditoria',               subtitle: 'Histórico das ações realizadas no sistema' },
  RolePermissionsPage: { title: 'Permissões',            subtitle: 'Páginas liberadas para cada perfil de usuário' },
  ClinicalDashboardPage:  { title: 'Resultados da Unidade', subtitle: 'Indicadores, semanas e contadores do mês' },
  ClinicalDailyEntryPage: { title: 'Lançamento Diário',  subtitle: 'Registro diário de resultados da unidade' },
  ClinicalGoalsPage:      { title: 'Metas da Unidade',   subtitle: 'Metas e contadores de produção' },
  ClinicalExpensesPage:   { title: 'Despesas / DRE',     subtitle: 'Despesas do período e resultado da unidade' },
  ReplicateTemplatePage:  { title: 'Replicar Modelo Padrão', subtitle: 'Copiar o modelo padrão para outra empresa' },
  SupportMaterialsPage:      { title: 'Materiais de Apoio', subtitle: 'Arquivos e links da DHR Consultoria para mentorados' },
  SupportMaterialsAdminPage: { title: 'Materiais de Apoio — gestão', subtitle: 'Envie e organize os materiais dos mentorados' },
  MyPlanPage:        { title: 'Meu Plano',               subtitle: 'Plano, pagamento e acessos da sua empresa' },
  SubscriptionsAdminPage: { title: 'Planos e Assinaturas', subtitle: 'Plano e situação de pagamento de cada empresa' },
  PlanSelection:     { title: 'Bem-vindo à DHR Gestão',  subtitle: 'Escolha o plano para começar' },
  MyTrainingPage:    { title: 'Meus Treinamentos',       subtitle: 'Cursos de capacitação liberados para você' },
  BackupPage:        { title: 'Backup do Sistema',       subtitle: 'Exporte ou restaure todos os dados do DHR Gestão' },
};

const Header = ({ currentComponent, user, onLogout, onMenuClick }) => {
  const page = pageNames[currentComponent] || { title: 'DHR Gestão', subtitle: '' };

  return (
    <header className="topbar">
      <div className="topbar-left">
        {onMenuClick && (
          <button type="button" className="topbar-menu-btn" onClick={onMenuClick} aria-label="Abrir menu">
            <LuMenu />
          </button>
        )}
        <div className="topbar-heading">
          <div className="topbar-title">{page.title}</div>
          <div className="topbar-breadcrumb">{page.subtitle}</div>
        </div>
      </div>
      <div className="topbar-right">
        <CompanySwitcher />
        <div className="topbar-badge">
          <LuUserCircle />
          {user?.username || 'Usuário'}
        </div>
        <button
          className="topbar-logout"
          onClick={onLogout}
          title="Sair"
          style={{
            background: 'none',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '6px 12px',
            cursor: 'pointer',
            color: 'var(--text-3)',
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontFamily: 'inherit',
            transition: 'color 0.15s, border-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--danger)'; e.currentTarget.style.borderColor = 'var(--danger-border)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-3)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
        >
          <LuLogOut />
          <span className="topbar-logout-label">Sair</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
